import React from "react";
import  { useState, useEffect } from 'react';
import './classes/EditScoutMessage.css';
import SalespersonSidebar from './SalespersonSidebar';
import Editor from 'react-simple-wysiwyg';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import ViewScoutMessage from "./ViewScoutMessage";

const EditScoutMessage = () => {

    const initialEditScoutForm = {
        edit_scout_message_title: '',
        summary: '',
        body: '',
        field_meta_title: '',
        field_meta_keywords:'',
        field_meta_description:'',
    };

    const location  = useLocation();
    const [previewData, setPreviewData] = useState();
    const [toggle, setToggle] = useState(2);
    const [errors, setErrors] = useState({});
    const [showSummary, setShowSummary] = useState(false);
    const [useRichEditor, setUseRichEditor] = useState(true);
    const [PreviewFields, setPreviewFields] = useState(false);
    const [viewChanges,setViewChanges] = useState(false);
    const [formDataSnapshot, setFormDataSnapshot] = useState(null);
    const [originalData, setOriginalData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialEditScoutForm);
    const [savedData, setSavedData] = useState(initialEditScoutForm);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
	const successMessage = location.state?.message; // Access the message
     window.history.replaceState({}, '');							 
    const navigate = useNavigate();
    var {tab} = useParams();
    const app_url = configData.APP_URL;
   
    const {aid} = useParams();

    // const getPageTitle = () => {
    //     if (toggle === 1) {
    //         return savedData.edit_scout_message_title
    //             ? `${savedData.edit_scout_message_title}`
    //             : 'View Scout Message';
    //     } else {
    //             return savedData.edit_scout_message_title
    //             ? `Edit Scout Message ${savedData.edit_scout_message_title}`
    //             : 'Edit Scout Message';
    //     }
    // };

    const onEditorChange = (field, e, isRich = true) => {
        let newHtml = e.target.value;

        // Normalize editor output
        const isEmptyHtml = newHtml.trim() === '' || newHtml === '<br>' || newHtml === '<p><br></p>';

        if (isEmptyHtml) {
            newHtml = '';
        } else if (isRich && !newHtml.trim().startsWith('<')) {
        // Wrap plain text in <p> if it's not already HTML
            newHtml = `<p>${newHtml}</p>`;
        }

        setFormData(prev => ({ ...prev, [field]: newHtml }));
    };

    // const cleanHtmlOutput = (html) => {
    //     if (!html) return '';

    //     let cleaned = html;

    //     cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

    //     cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

    //     const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

    //     return textOnly.length === 0 ? '' : html.trim();
    // };
    // const handleEditorChange = (e) => {
    //     setFormData(prev => ({
    //         ...prev,
    //         body: e.target.value
    //     }));
    // };

    const handleViewChangesClick = () => {
        setPreviewFields(false);
        const newErrors = {};

        if (!formData.edit_scout_message_title.trim()) {
            newErrors.edit_scout_message_title = 'Title field is required.';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).some(key => newErrors[key])) {
            setViewChanges(false);
            return;
        }

        setViewChanges(true);
        // setOriginalData(savedData);
        setFormDataSnapshot(formData);
        window.scrollTo(0, 0);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.edit_scout_message_title.trim()) {
            newErrors.edit_scout_message_title = "Title field is required.";
        }
        return newErrors;
    };

    const inputStyle = {
        border: errors.edit_scout_message_title ? '2px solid red' : '1px solid #777',
    };


        // Utility to convert HTML to plain text with line breaks
    const extractFirst7LinesHtml = (html) => {
        // Tags that count as visual "lines"
        const lineBreakTags = ['p', 'div', 'li', 'h1', 'h2', 'h3', 'h4', 'br'];

        // Normalize self-closing <br> to full tags for easier matching
        const normalizedHtml = html.replace(/<br\s*\/?>/gi, '<br></br>');

        const regex = new RegExp(
            `<(?:${lineBreakTags.join('|')})[^>]*>.*?<\\/\\s*(?:${lineBreakTags.join('|')})\\s*>`,
            'gis'
        );

        const matches = [...normalizedHtml.matchAll(regex)];

        let extracted = '';
        let count = 0;

        for (let match of matches) {
            if (count >= 9) break;
            extracted += match[0];
            count++;
        }

        if (count < 9) {
            const parts = html.split(/(?=<)/); 
            extracted = '';
            count = 0;

            for (let i = 0; i < parts.length; i++) {
                extracted += parts[i];
                if (/<\/?(p|div|li|h[1-4]|br)[^>]*>/i.test(parts[i])) {
                    count++;
                }
                if (count >= 9) break;
            }
        }

        return extracted.trim();
    };


    const handlePreviewClick = () => {
        setViewChanges(false);
        if (formData.edit_scout_message_title.trim()) {
            const bodyHtml = formData.body || '';
            const hasBreak = bodyHtml.includes('<!--break-->');
            const breakSummary = hasBreak
                ? bodyHtml.split('<!--break-->')[0]
                : null;

            let finalSummary = formData.summary?.trim();

            if (!finalSummary) {
                if (breakSummary !== null) {
                    finalSummary = breakSummary;
                } else {
                    finalSummary = extractFirst7LinesHtml(bodyHtml);
                }
            }


            setPreviewData({
                title: formData.edit_scout_message_title,
                summary: finalSummary,
                body: bodyHtml
            });

            setPreviewFields(true);
            setErrors(prev => ({ ...prev, edit_scout_message_title: null }));
            window.scrollTo(0, 0);
        } else {
            setErrors(prev => ({
                ...prev,
                edit_scout_message_title: "Title field is required."
            }));
            setPreviewFields(false);
            window.scrollTo(0, 0);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const validationErrors = validateForm();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            
            setSavedData(formData); 
            window.scrollTo(0, 0);
            setPreviewFields(false); 
            setViewChanges(false);
			 const postData = formData;
             const response = await fetch(app_url + 'smwwscout/putscoutmessage', {
                method: 'POST',
                body: JSON.stringify(postData),
                headers: {
                     'Content-Type': 'application/json',
             },
            });
            const data = await response.json();
             if(data.data.msg == "Success") {
                
                 navigate('/scout-message/'+aid+'/view', { state: { message: data.data.result } });
            } 
        }
    };

    // const handleSubmit = async event => {
    //     event.preventDefault();
    
    //     if (validate()) {
  
    //         const postData = formData;
    //         const response = await fetch(app_url + '', {
    //             method: 'POST',
    //             body: JSON.stringify(postData),
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         });
    //         const data = await response.json();
    //         if(data.data == "Success") {
        
    //             navigate('/manage-emails', { state: { message: data.data.result } });
    //         } 
        
       
    //     } else {
      
    //     }
    // };

    const updateToggle = (id) => {
        setToggle(id);
    
       if(id == 1) { 
        
            navigate("/scout-message/"+aid+"/view");
        }
        if(id == 2) { 
            navigate("/scout-message/"+aid+"/edit");
        }
	 
		
    }

   async function retrieveUserLoggedinroles() {
    
    
      try {
        setIsLoading(true);
    const response = await fetch(
      app_url+'viewprofile/getuserloggedinrolesid',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
   setUserLoggedInRoles(responsedata.data.roles)
    }
     }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
           
          }
  
  }
    useEffect(() => {
        Promise.all([
          retrieveEditScoutMessage(),
           retrieveUserLoggedinroles()
          ]).then(() => {
     
            setIsLoading(false);
             if(tab == "view") {
            setToggle(1);
        }
        if(tab == "edit") {
            setToggle(2);
        }
          })
   
    },[tab]);
    async function  retrieveEditScoutMessage() {
        const response = await fetch(
        app_url+'smwwscout/retrievescoutmessage?id='+aid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            const updatedForm = {
                edit_scout_message_title: responsedata.data.result.edittitle,
                summary: responsedata.data.result.editsummary,
                body: responsedata.data.result.editbody,
                field_meta_title: responsedata.data.result.field_meta_title,
                field_meta_keywords: responsedata.data.result.field_meta_keywords,
                field_meta_description: responsedata.data.result.field_meta_description,
                id:aid
            };

            setFormData(updatedForm);
            setOriginalData(updatedForm); 

        }
    }


    const handleDelete = async () => {
        const confirmed = window.confirm("Are you sure you want to delete this message?");
        if (confirmed) {
         const response = await fetch(
        app_url+'smwwscout/deletescoutmessage?id='+aid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            navigate('/saadmin/manage-scout-message', { state: { message: responsedata.data.result } });
           
        }
		 
        }
    };

    const getPageTitle = () => {
      const title = originalData?.edit_scout_message_title || "";

      if (toggle === 1) {
        return title ? title : "Scout Message";
      } else if (toggle === 2) {
        return title ? `Edit Scout Message ${title}` : "Edit Scout Message";
      }

      return "Scout Message"; // default fallback
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet>
                        <title>
                            {getPageTitle()}
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                         {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                                                <>
                        {toggle === 2 && PreviewFields && (
                            <>
                                <div 
                                    className="messages status" 
                                    style={{ background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,backgroundPosition: '10px 10px' }}
                                >
                                    The trimmed version of your post shows what your post looks like when promoted to the main page or when exported for syndication.
                                    <span>
                                        You can insert the delimiter "&lt;!--break--&gt;" (without the quotes) to fine-tune where your post gets split.
                                    </span>
                                </div>
                            </>
                        )}
					 {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                        <div className='button_wrap'>
                            <ul class="scout-message-primary">
                                <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View</a></li>
                                <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>
                            </ul>      
                        </div>
                        </>
                        }
                        <div  className= {toggle === 1? "show-content" : "content"}>
                            <ViewScoutMessage savedData={savedData} />
                        </div>
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                                                <>
                        <div  className= {toggle === 2? "show-content" : "content"}>
                            <div className="edit-scout-message-container">
                                <div>
                                    {PreviewFields && (
                                        <>
                                            <div className="preview-container">
                                                <div className='preview-trimmed'>
                                                    <h4 className="preview-heading">
                                                        Preview trimmed version
                                                    </h4>
                                                    <div className="message-teaser">
                                                        <h2 className="message-title">
                                                            <a href onClick={()=> updateToggle(1)}>{previewData?.title}</a>
                                                        </h2>
                                                        <div className="message-teaser-block1">
                                                            <div className="message-teaser-block2">
                                                                {previewData.summary && (
                                                                    <div dangerouslySetInnerHTML={{ __html: previewData.summary }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="read-more-link">
                                                            <a href="#" onClick={()=> updateToggle(1)}>Read more</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='preview-full'>
                                                    <h4 className="preview-heading">
                                                        Preview full version
                                                    </h4>

                                                    <div className="message-teaser">
                                                        <h2 className="message-title">
                                                            Body:
                                                        </h2>
                                                        <div className="message-teaser-block1">
                                                            <div className="message-teaser-block2">
                                                                <div dangerouslySetInnerHTML={{ __html: previewData.body }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div>
                                    {viewChanges && (
                                        <div className='diff-table-wrapper'>
                                            <table className="diff-table">
                                                <colgroup>
                                                    <col className="diff-marker" style={{width: "2%"}} />
                                                    <col className="diff-content" style={{width: "48%"}} />
                                                    <col className="diff-marker" style={{width: "2%"}} />
                                                    <col className="diff-content" style={{width: "48%"}} />
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                    <th colSpan="2">Original</th>
                                                    <th colSpan="2">Changes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!formDataSnapshot || !originalData ? (
                                                    <tr className="no-changes">
                                                        <td className="diff-section-title" colSpan="4">No visible changes</td>
                                                    </tr>
                                                    ) : (
                                                    (() => {
                                                        const diffs = [];

                                                        const compareField = (label, oldValue = '', newValue = '') => {
                                                        if (oldValue === newValue) return null;

                                                        const oldLines = (oldValue ?? '').split('\n');
                                                        const newLines = (newValue ?? '').split('\n');
                                                        const maxLines = Math.max(oldLines.length, newLines.length);

                                                        const rows = [
                                                            <tr className="diff-section-title" key={`${label}-title`}>
                                                            <td colSpan="4">Changes to <em>{label}</em></td>
                                                            </tr>
                                                        ];

                                                        for (let i = 0; i < maxLines; i++) {
                                                            const oldLine = (oldLines[i] || '').trim();
                                                            const newLine = (newLines[i] || '').trim();

                                                            if (oldLine !== newLine) {
                                                            const oldWords = oldLine.split(/\s+/);
                                                            const newWords = newLine.split(/\s+/);
                                                            const maxWords = Math.max(oldWords.length, newWords.length);

                                                            const renderWords = (wordsA, wordsB, isOld) =>
                                                                wordsA.map((word, idx) => {
                                                                const matchingWord = wordsB[idx] || '';
                                                                const changed = word !== matchingWord;

                                                                return (
                                                                    <span
                                                                    key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
                                                                    style={changed ? {
                                                                        color: isOld ? 'red' : 'red',
                                                                        borderRadius: '4px',
                                                                        padding: '0 3px',
                                                                        fontWeight:'bold'
                                                                    } : {}}
                                                                    >
                                                                    {word}
                                                                    {' '}
                                                                    </span>
                                                                );
                                                                });

                                                            rows.push(
                                                                <tr key={`${label}-${i}`}>
                                                                <td style={{width:"2px"}}><span>-</span></td>
                                                                <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
                                                                <td style={{width:"2px"}}><span>+</span></td>
                                                                <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
                                                                </tr>
                                                            );
                                                            }
                                                        }

                                                        return rows;
                                                        };

                                                        diffs.push(...(compareField('Title', originalData.edit_scout_message_title, formDataSnapshot.edit_scout_message_title) || []));
                                                        diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
                                                        diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));
                                                        diffs.push(...(compareField('Meta Title', originalData.field_meta_title, formDataSnapshot.field_meta_title) || []));
                                                        diffs.push(...(compareField('Meta Keywords', originalData.field_meta_keywords, formDataSnapshot.field_meta_keywords) || []));
                                                        diffs.push(...(compareField('Meta Description', originalData.field_meta_description, formDataSnapshot.field_meta_description) || []));
                                                        return diffs.length > 0 ? diffs : (
                                                            <tr className="no-changes">
                                                                <td className="diff-section-title" colSpan="4">No visible changes</td>
                                                            </tr>
                                                        );
                                                    })()
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div>
                                        <div className="form-item">
                                            {errors.edit_scout_message_title && (
                                                <div 
                                                    className="form-error" 
                                                    style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") no-repeat 2px`}}
                                                >
                                                    {errors.edit_scout_message_title}
                                                </div>
                                            )}
                                            <label htmlFor="edit-scout-message-title">
                                                Title  
                                                <span className="form-required" title="This field is required.*">*</span>
                                            </label>
                                            <input 
                                                className="edit-scout-message-title-field" 
                                                type="text" 
                                                id="edit-scout-message-title" 
                                                name="edit_scout_message_title" 
                                                maxLength={100} 
                                                onChange={handleChange}
                                                style={inputStyle} 
																																		   
                                                value={formData.edit_scout_message_title}
                                            />
                                        </div>
                                        <div className="editscoutmessage-format-wrapper">
                                            <div>
                                                {showSummary && (
                                                    <div className="form-item">
                                                        <label htmlFor="edit_summary">
                                                            Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                                        </label>
                                                        <>
                                                            <>
                                                                <Editor 
                                                                    containerProps={{ style: { resize: 'vertical' } }} 
                                                                    value={formData.summary} 
                                                                    onChange={e => onEditorChange('summary', e)}
                                                                />
                                                            </>
                                                        </>
                                                        <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                    </div>
                                                )}
                                        
                                                <div className="form-item">
                                                    <label htmlFor="edit_body">
                                                        Body 
                                                        {!showSummary && (
                                                            <span>
                                                                (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                                    Edit Summary
                                                                </a>)
                                                            </span>
                                                        )}
                                                    </label>
                                                    <>
                                                        {useRichEditor ? (
                                                            <> 
                                                                <Editor 
                                                                    containerProps={{ style: { resize: 'vertical', height:'300px' } }} 
                                                                    value={formData.body} 
                                                                    onChange={e => onEditorChange('body', e, true)}
                                                                />  
                                                                <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                                    Switch to plain text editor
                                                                </a>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <textarea
                                                                    id="edit_body"
                                                                    rows="20"
                                                                    value={formData.body} 
                                                                    onChange={e => onEditorChange('body', e, false)} 
                                                                />
                                                                <div 
                                                                    className="grippie" 
                                                                    style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                                >
                                                                </div>
                                                                <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                                    Switch to rich text editor
                                                                </a>
                                                            </>
                                                        )}
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="meta_title">Meta Title</label>
                                            <input className="create-scout-message-text-field" type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} onChange={handleChange}  /> 
                                        </div>
                                        <div className="form-item">
                                            <label htmlFor="meta_keywords">Meta Keywords</label>
                                            <input className="create-scout-message-text-field" type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} onChange={handleChange}  /> 
                                        </div>
                                        <div className="form-item">
                                            <label>Meta Description</label>
                                            <textarea
                                                name="field_meta_description"
                                                rows="5"
                                                value={formData.field_meta_description}
                                                onChange={handleChange}
                                            />
                                            <div className="grippie" style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}>
                                            </div>
                                        </div>
                                        <div className="form-actions form-wrapper" id="edit-actions">
                                            <input 
                                                type="submit" 
                                                id="edit-submit" 
                                                name="" 
                                                value="Save" 
                                                className="form-submit" 
                                            />
                                            <input 
                                                type="button" 
                                                id="edit-preview"  
                                                value="Preview" 
                                                className="form-submit" 
                                                onClick={()=> {handlePreviewClick();}} 
                                            />
                                            <input 
                                                type="button" 
                                                id="view-changes"  
                                                value="View Changes" 
                                                className="form-submit" 
                                                onClick={()=> {handleViewChangesClick();}} 
                                            />
                                            <input 
                                                type="button" 
                                                id="edit-delete" 
                                                name="" 
                                                value="Delete" 
                                                className="form-submit" 
                                                onClick={handleDelete}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                      </>
                }  
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default EditScoutMessage;